module.exports = __webpack_public_path__ + "img/warehouse-management.36472335.png";